import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import HeroEmpleo from '../Components/HeroEmpleo';
import Trabaja from '../Components/Trabaja';

const Empleo = () => {
    return (
        <div className="h-full overflow-x-hidden">
            <Header />
            <HeroEmpleo />
            <Trabaja />
            <Footer />
        </div>
    )
}

export default Empleo